import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AlertsModal from './AlertsModal';
import { useWishlist } from '../../../hooks/useWishlist';

export default function Navbar() {
  const navigate = useNavigate();
  const [showAlertsModal, setShowAlertsModal] = useState(false);
  const { wishlistCount } = useWishlist();

  return (
    <>
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div 
              onClick={() => navigate('/')}
              className="flex items-center gap-3 cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/a79cb0bec034472cb10b80478a2788a7.png" 
                alt="iCarga Logo" 
                className="h-12 w-12 rounded-full object-cover"
              />
              <span className="text-2xl font-bold text-gray-900">iCarGA</span>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={() => setShowAlertsModal(true)}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                title="Set Alerts"
              >
                <i className="ri-notification-line text-xl text-gray-600"></i>
              </button>

              <button
                onClick={() => navigate('/wishlist')}
                className="relative w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                title="My Wishlist"
              >
                <i className="ri-heart-line text-xl text-gray-600"></i>
                {wishlistCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
                    {wishlistCount > 9 ? '9+' : wishlistCount}
                  </span>
                )}
              </button>

              <button
                onClick={() => navigate('/compare')}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                title="Compare Vehicles"
              >
                <i className="ri-scales-line text-xl text-gray-600"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {showAlertsModal && <AlertsModal onClose={() => setShowAlertsModal(false)} />}
    </>
  );
}
